module.exports = __webpack_public_path__ + "static/media/sidebar_vendor_icon.d4fe5e22.svg";